const { default: axios } = require("axios");
const { default: UtilitiesUP } = require("./utilities");
const { default: Loader } = require("./Loader.js");
const { contains } = require("jquery");
const AudioRecorder = require("simple-audio-recorder");
const { message } = require("laravel-mix/src/Log");
const { forEach } = require("lodash");

const Chats = function () {

    var recorder = new AudioRecorder();

    const updateHeightList = function() {
        // console.log('atualizou')
        // var adjHeigh = $("#chat-list").height();
        // setTimeout(()=>{
        //     $("#chat-list").height(adjHeigh - 55);
        //     $("#card-custom-chat").height(adjHeigh - 32);
        //     $("#body-chat").height(adjHeigh - 300);
        // },500)

        // chats v3 - com header
        if($("#card-body-chat").find('.max-full-h').hasClass('max-full-h--with-header')){
            let heightHeaderChat = (118 + 57); // 118 header + 79 footer chat
            setTimeout(()=>{
                $("#body-chat").height($("#chat-list").height() - heightHeaderChat);
            },1000)
        }

    }

    const searchListContact = function () {
        const element = $(this);
        const url = element.closest('form').attr('action');

        KTApp.block('#kt_chat_content');

        axios.get(url)
            .then(function (response) {
                const data = response.data;
                const result = data.result;


                if (data.error === false) {
                    
                } else {
                    console.log('ops, ocorreu um erro');
                }
            });
    }

    const toggleChatMobile = function ()
    {

        if( $(window).width() <= 992 )
        {
            $("#kt_chat_aside").toggle();
            $("#kt_chat_content").toggle();            
        } 

    }

    const open = function () {
        const element = $(this);
        const url = element.data('url');

        toggleChatMobile();

        $(".act-open-chat").removeClass('contactActived');
        element.addClass('contactActived');

        element.find('.message-not-read').css('display', 'none');

        KTApp.block('#kt_chat_content');

        axios.get(url)
            .then(function (response) {
                const data = response.data;
                const result = data.result;

                if (data.error === false) {
                    $('.response-chat').html(result.html);

                    const utilitiesClass = new UtilitiesUP;
                    utilitiesClass.formSelects();

                    KTLayoutChat.setup(KTUtil.getById('kt_chat_content'));
                    KTApp.unblock('#kt_chat_content');

                    // $('.response-chat .scroll').animate({
                    //     scrollTop: $('#kt_chat_content .card-body .messages').height()
                    // }, 1000);
                    $('.select2').select2();

                    if($('.messages-chat-whats').hasClass('v3')){
                        console.log('chats v3');
                        if($('.chat-scroll-pagination').length > 0) {
                            $('.chat-scroll-pagination').on('scroll', scrollToPaginateInfinity)
                        }
                        $('.messages-chat-whats').animate({
                            scrollTop: ($('#kt_chat_content .resp-baloon').last().offset()!==undefined?$('#kt_chat_content .resp-baloon').last().offset().top:0)
                        }, 1000);
                    } else {
                        console.log('chats v2');
                        $('.response-chat .scroll').animate({
                            scrollTop: $('#kt_chat_content .card-body .messages').height()
                        }, 1000);   

                    }

                    updateHeightList();
                    start(result.chatRoom);
                }else{
                    KTApp.unblock('#kt_chat_content');
                    Swal.fire({
                        icon: "error",
                        text: data.message,
                        showCancelButton: false,
                    })
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            })
            .catch(function (error) {
                const classUtilitites = new UtilitiesUP;
                classUtilitites.showCommunicationError(error);
                console.log(error);
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            });;
    }

    const chatList = function () {
        const room = client_name + ".chat-list";

        Echo.leave(room);
        Echo.channel(room)
            .listen('ChatList', function (response) {

                var url = $("#kt_chat_aside #chat-list").data('url') + '?chat_id=' + response.chat.id;

                filterData = {'return':'json'};

                if($('#responsibleFilter').length > 0) filterData.responsible = $('#responsibleFilter').find(":selected").val();
                filterData.value_field =  $('#searchField').val();

                var sendData = { ...response.chat, ...filterData };

                axios.post(url, sendData)
                    .then(response => {
                        const data = response.data;
                        const result = data.result;

                        if (data.error === false) {
                            var target = "";

                            if(result.target === undefined) 
                                target = '#kt_chat_aside .card-body'; 
                            else 
                                target = result.target; 
                            
                            if($(result.id).length > 0){
                                $(result.id).remove();
                            }

                            $(target).prepend(result.html);
                        }

                    })
                    .catch(function (error) {
                        // const classUtilitites = new UtilitiesUP;
                        // classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                        // console.log(error);
                    });

            });
    }

    const start = function (room) {
        Echo.leave(room);
        Echo.private(room)
            .listen('ChatMessage', (response) => {
                var messageElement = 0;
                if(response.transaction_code != undefined && response.transaction_code != null){
                    var transaction_code = response.transaction_code;
                    messageElement = $("#"+transaction_code).length;
                }
                
                if((typeof transaction_code === 'undefined') || messageElement == 0){
                    const url = $(document).find('#kt_chat_content .messages').data('format');

                    filterData = {'return':'json'};
                    
                    if($('#responsibleFilter').length > 0) filterData.responsible = $('#responsibleFilter').find(":selected").val();

                    var sendData = { ...response.chatMessage, ...filterData };


                    axios.post(url, sendData)
                        .then(function (response) {
                            const data = response.data;
                            const result = data.result;   
                            
                            if (data.error == false) {
                                let sectionMessages = $(document).find('#kt_chat_content .messages');
    
                                if (result.user_id == sectionMessages.data('user_id') && result.chat_channel_id == sectionMessages.data('chat_channel_id')) {
                                    sectionMessages.append(result.html);

                                    if(result.html_footer != undefined && $('#content').length == 0){
                                        $('#kt_chat_content .card-footer').replaceWith(result.html_footer);
                                    }
    
                                    $('.scroll').animate({
                                        scrollTop: $('#kt_chat_content .card-body .messages').height()
                                    }, 100);
    
                                    let context = new AudioContext();
                                    if (context.state == "running") {
                                        document.getElementById('audio-notification').play()
                                    }
                                }
                            }
                        })
                        .catch(function (error) {
                            const classUtilitites = new UtilitiesUP;
                            classUtilitites.showCommunicationError(error);
                            console.log(error);
                        });
                }else{
                    const url = $(document).find('#kt_chat_content .messages').data('update-message');

                    axios.post(url, response.chatMessage)
                        .then(function (response) {
                            const data = response.data;
                            const result = data.result;

                            $(result.target).replaceWith(result.html);
    
                            $('.scroll').animate({
                                scrollTop: $('#kt_chat_content .card-body .messages').height()
                            }, 100);

                            if(result.error_json != undefined && result.error_json != ''){
                                if(result.error_json.action != undefined){
                                    if (result.error_json.action ==="sendFlow") {
                                        const classUtilitites = new UtilitiesUP;
                                        classUtilitites.showAlert(result.error_json.translated_error, "Ok");
                                        location.reload();
                                    }
                                }
                            }
                            
                        })
                        .catch(function (error) {
                            // const classUtilitites = new UtilitiesUP;
                            // classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                            // console.log(error);
                        });
                }

            });
    }

    const sendMessage = function (event) {
        event.preventDefault()

        const element = $(this);

        if(event.target.classList.contains('waiting-send')) return;

        event.target.classList.add('waiting-send');
        
        // element.find('button.chat-send').attr('disabled', 'disabled');
        element.find('button.chat-send').prop('disabled', true);



        $(".fDerror").hide();
        var errorFD = 0;

        $(".validate-flow_paramns").each(function(){
            if( $(this).val() == "") {
                errorFD = 1;
            }            
        });
        
        if(errorFD > 0) {
            $(this).parent().find('.fDerror').show();
            return false;
        }

        const url = element.attr('action');
        const data = element.serialize();

        if (data.indexOf("flow_id") > 0) {
            KTApp.block('.chat-close');
        }

        axios.post(url, data)
            .then(function (response) {
                const data = response.data;
                const result = data.result;

                if (data.error) {

                    let changeFooter = ["needs_message_template", "chat_close"];

                    if (changeFooter.includes(result.error_slug)) {
                        /* $('#kt_chat_content .card-footer').remove();
                        $('#kt_chat_content .card-body').after(result.html); */
                        $("#chat-card-footer").remove();
                        $('#card-body-chat').after(result.html);
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: data.message
                    });

                    if(element.find('#content').val() != '') element.find('button.chat-send').prop('disabled', false);//element.find('button.chat-send').removeAttr('disabled');

                } else {
                    element.find('#content').val("");
                    //textarea volta tamanho normal
                    $('.textarea-autoHeight').height('auto');

                    $('.chat-close, .chat-open').addClass('d-none');

                    if (result.success_slug == "flow_processed") {
                        $('.chat-open').removeClass('d-none');
                        /* $('#kt_chat_content .card-footer').remove();
                        $('#kt_chat_content .card-body').after(result.html); */
                        $("#chat-card-footer").remove();
                        $('#card-body-chat').after(result.html);

                        if(result.html_message !== undefined && result.html_message != '') $(document).find('#kt_chat_content .messages').append(result.html_message);

                        const utilitiesClass = new UtilitiesUP;
                        utilitiesClass.formSelects();

                        KTApp.unblock('.chat-close');

                    }

                    if (result.success_slug == "message_send") {
                        $('.chat-open').removeClass('d-none');
                        $("#whatsapi-send-button").hide();
                        $("#recordButton").show();
                        // $("#kt_chat_content .messages").append(result.html);
                        if(result.html !== undefined && result.html != '') $(document).find('#kt_chat_content .messages').append(result.html);

                        $('.scroll').animate({
                            scrollTop: $(document).find('#kt_chat_content .messages').height()
                            // scrollTop: $('#kt_chat_content .card-body .messages').height()
                        }, 100);
                    }

                    if(element.find('#content').val() != '') element.find('button.chat-send').prop('disabled', false);//element.find('button.chat-send').removeAttr('disabled');
                }
                event.target.classList.remove('waiting-send');
            })
            .catch(function (error) {
                const classUtilitites = new UtilitiesUP;
                classUtilitites.showCommunicationError(error);
                console.log(error);
            });
    }

    const sendFile = function (event) {

        var fileInput = document.getElementById('uploadFileChat');
        var blob = fileInput.files[0];
        var formData = new FormData();
        formData.append('userfile', blob);
        formData.append('content', '.');
        formData.append('sendFile', true);
        formData.append('chat_id', $("#uploadFileChat").data('chat_id'));

        if($("#user_id").length > 0)formData.append('user_id', $("#user_id").val());
        if($("#name_to").length > 0)formData.append('name_to', $("#name_to").val());
        if($("#ddi_to").length > 0)formData.append('ddi_to', $("#ddi_to").val());
        if($("#phone_to").length > 0)formData.append('phone_to', $("#phone_to").val());
        if($("#channel_id").length > 0)formData.append('channel_id', $("#channel_id").val());
        if($("#chat_type_id").length > 0)formData.append('chat_type_id', $("#chat_type_id").val());
        if($("#chat_type").length > 0)formData.append('chat_type', $("#chat_type").val());


        axios.post($('#uploadFileChat').data('url'), formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        }).then(function (response) {

            let data = response.data;


            if (data.error === false) {

                let result = data.result;
                $(document).find('#kt_chat_content .messages').append(result.html);

            } else {
                Swal.fire({
                    icon: "error",
                    text: data.message,
                    showCancelButton: false,
                })
                if (data.result.method != undefined) {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }

            $("#stopButton").addClass("d-none");
            $("#recordButton").removeClass("d-none");
            $("#stopButton").html($("#stopButton").attr('data-val'));

            $('.scroll').animate({
                scrollTop: $('#kt_chat_content .card-body .messages').height()
            }, 100);
        });

    }

    // const startRecording = function (event) {
    //     $("#recordButton").addClass("d-none");
    //     $("#stopButton").removeClass("d-none");
    //     $("#stopButton").css('pointer-events', 'all');

    //     navigator.mediaDevices.getUserMedia({ audio: true })
    //         .then(function (stream) {
    //             recorder = new MediaRecorder(stream);

    //             // when there is data, compile into object for preview src
    //             recorder.ondataavailable = function (e) {
    //                 let blob = new Blob([e.data], { type: "audio/mpeg-3" });
    //                 let formData = new FormData();
    //                 formData.append('audio', blob, 'audio.mp3');
    //                 formData.append('content', '.');
    //                 formData.append('audio', true);
    //                 formData.append('chat_id', $("#stopButton").data('chat_id'));

    //                 axios.post($('#stopButton').data('url'), formData, {
    //                     headers: {
    //                         "Content-Type": "multipart/form-data"
    //                     },
    //                 })
    //                     .then(function (response) {

    //                         let data = response.data;


    //                         if (data.error === false) {

    //                             let result = data.result;
    //                             $(document).find('#kt_chat_content .messages').append(result.html);

    //                         } else {
    //                             Swal.fire({
    //                                 icon: "error",
    //                                 text: data.message,
    //                                 showCancelButton: false,
    //                             })
    //                             if (data.result.method != undefined) {
    //                                 setTimeout(function () {
    //                                     location.reload();
    //                                 }, 1000);
    //                             }
    //                         }

    //                         $("#stopButton").addClass("d-none");
    //                         $("#recordButton").removeClass("d-none");
    //                         $("#stopButton").html($("#stopButton").attr('data-val'));

    //                         $('.scroll').animate({
    //                             scrollTop: $('#kt_chat_content .card-body .messages').height()
    //                         }, 100);


    //                     });
    //             };
    //             recorder.start();

    //             timeout_status = setTimeout(function () {
    //                 console.log("5 min timeout");
    //                 stopRecording();
    //             }, 300000);
    //         });
    // }

    // const stopRecording = function (event) {

    //     let val = $("#stopButton").html();

    //     $("#stopButton").attr('data-val', val);
    //     $("#stopButton").html($("#stopButton").attr('data-wait'));
    //     $("#stopButton").css('pointer-events', 'none');

    //     recorder.stop();

    // }

    const startRecording = function (event) {

        $("#overlay-rec-audio-chat").fadeIn(50);

        $("#recordButton").addClass("d-none");
        $("#stopButton").removeClass("d-none");
        $("#stopButton").css('pointer-events', 'all');

        AudioRecorder.preload("https://cdn.jsdelivr.net/npm/simple-audio-recorder@0.0.3/dist/mp3worker.js");

        recorder.start().then(() => {
            console.log("Recording started...");
        }).catch(error => {
            console.log(error);
            $("#overlay-rec-audio-chat").fadeOut(50);
        });
    }

    const stopRecording = function (event) {

        $("#overlay-rec-audio-chat").fadeOut(50);

        let val = $("#stopButton").html();

        $("#stopButton").attr('data-val', val);
        $("#stopButton").html($("#stopButton").attr('data-wait'));
        $("#stopButton").css('pointer-events', 'none');

        recorder.stop().then(mp3Blob => {
            console.log("Recording stopped...");

            let formData = new FormData();
            formData.append('audio', mp3Blob, 'audio.mp3');
            formData.append('content', '.');
            formData.append('audio', true);
            formData.append('chat_id', $("#stopButton").data('chat_id'));

            if($("#user_id").length > 0)formData.append('user_id', $("#user_id").val());
            if($("#name_to").length > 0)formData.append('name_to', $("#name_to").val());
            if($("#phone_to").length > 0)formData.append('phone_to', $("#phone_to").val());
            if($("#channel_id").length > 0)formData.append('channel_id', $("#channel_id").val());
            if($("#chat_type_id").length > 0)formData.append('chat_type_id', $("#chat_type_id").val());
            if($("#chat_type").length > 0)formData.append('chat_type', $("#chat_type").val());
            if($("#ddi_to").length > 0)formData.append('ddi_to', $("#ddi_to").val());

            axios.post($('#stopButton').data('url'), formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            })
                .then(function (response) {

                    let data = response.data;


                    if (data.error === false) {

                        let result = data.result;

                        // console.log($(document).find('#'.result.message_id));
                        // console.log($(document).find('#'.result.message_id).length);

                        // $(document).find('#kt_chat_content .messages').append(result.html);

                        if(result.transaction_code !== undefined){
                            console.log($(document).find('#'.result.transaction_code));
                            console.log($(document).find('#'.result.transaction_code).length);
                            if($(document).find('#'.result.transaction_code).length > 0){
                                $(document).find('#'.result.transaction_code).replaceWith(result.html);
                            }
                        }else{
                            $(document).find('#kt_chat_content .messages').append(result.html);
                        }

                    } else {
                        Swal.fire({
                            icon: "error",
                            text: data.message,
                            showCancelButton: false,
                        })
                        if (data.result.method != undefined) {
                            setTimeout(function () {
                                location.reload();
                            }, 1000);
                        }
                    }

                    $("#stopButton").addClass("d-none");
                    $("#recordButton").removeClass("d-none");
                    $("#stopButton").html($("#stopButton").attr('data-val'));

                    $('.scroll').animate({
                        scrollTop: $('#kt_chat_content .card-body .messages').height()
                    }, 100);


                });

        }).catch(error => {
            console.log(error);
        });
    }

    const selectFlow = function () {

        var demoTextarea = $("#box-textarea-realtime");

        console.log('one...');
        const element = $(this);

        if(element.val() != "") {
            $("#container-flow").show();
        } else {
            $("#container-flow").hide();
        }

        const value = element.val();
        const url = element.data('url');
        KTApp.block('#container-flow');

        axios.post(url, {
            flow: value
        })
        .then(function (response) {
            const data = response.data;
            const result = data.result;

            let newValue = "";
            if (data.error === false) {
                newValue = result.content;

                let params = JSON.parse(result.params);
                let flowParams = "";
                $('#container-flow-params').html("");

                // param = 1 => up_cliente, 2 => up_corretor
                if(params !== null ) 
                {
                    
                    Object.keys(params).forEach(key => {
                        if (params[key] !== 'huggy.chat.contact.name') {
                            flowParams += '<label for="flow-param-' + key + '" class="form-label font-size-sm mt-3">Parâmetro ' + key + ' *</label><div class="mb-3 d-flex rounded bg-gray-200 position-relative"><textarea name="flow_param[' + params[key] + ']" id="flow-param-' + key + '" class="textarea-js-param-realtime form-control rounded bg-gray-200 border-0 validate-flow_paramns count-caracteres textarea-autoHeight template-item-'+ params[key] +'" maxlength="500" rows="1" data-key="'+ key +'"></textarea> <div class="limite-textarea-abs"><span class="limite-textarea font-size-xs text-muted"></span> </div></div><span style="display:none;" class="text-danger fDerror font-size-xs mt-2">*Campo obrigatório.</span>';
                        }

                        setTimeout(() => {
                            let strLoad = demoTextarea.html();
                            strReplaceDinamic(key,strLoad,$(`#flow-param-${key}`).val());
                        }, 500);
                        
                    });

                    $(document).on('keyup', '.textarea-js-param-realtime', function(){

                        let el = $(this);
                        let strText = demoTextarea.html();
                        let newStr = el.val();
                        let key = el.attr('data-key');

                        strReplaceDinamic(key,strText,newStr);

                    });

                    /* Substituo os parametros {{1}} 2 {{2}} por classes para serem dinamicas ao digitar */
                    function strReplaceDinamic(nKey, nStr,vHtml){
                        demoTextarea.html(nStr.replace('{{'+nKey+'}}', "<span class='text-success param-"+nKey+"'></span>")); 
                        $('.param-'+nKey).html(vHtml);
                        if($('.param-'+nKey).is(':empty')) {
                            $('.param-'+nKey).html('___');
                        }
                    }

                    // wrap dos textareas dinamicos cliente e corretor
                    $('#container-flow-params').html(flowParams);

                    // textarea do corretor
                    if ($('.template-item-up_corretor').length > 0) {
                        $('.template-item-up_corretor').val(result.user_responsable);
                    }

                    // textarea do cliente
                    if ($('.template-item-up_client').length > 0) {
                        $('.template-item-up_client').val(result.client);
                    }

                    // autoHeightTextarea(element.find('.textarea-autoHeight'));
                    $('textarea').each(function(i,e){
                        setTimeout(() => {
                            $(this).height('auto');
                            $(this).height($(this).get(0).scrollHeight) 
                        }, 500);
                    });
                } 

                // textarea main
                $("#flow_content").val(newValue);

                //demoTextarea.html($("#flow_content").val().replaceAll(" ", "&nbsp;").replace(/\r\n|\r|\n/g, "<br />"));

                
                // cópia exata do textarea, essa demo é a visual ao entrar no chat template
                const copyText = $("#flow_content").val().replaceAll(" ", "&nbsp;").replace(/\r\n|\r|\n/g, "<br />");

                // trato &nbsp; para "" assim obedecendo quebras de linha no responsivo.
                demoTextarea.html(copyText.replace(/&nbsp;/g, " "));
                

            }

            
            KTApp.unblock('#container-flow');
        })
        .catch(function (error) {
            const classUtilitites = new UtilitiesUP;
            classUtilitites.showCommunicationError(error);
            console.log(error);
        });
    }

    const responsibleFilter = function() {
        var element = $(this);
    
        var elementData = $(this).data();
        if(elementData.select2 !== undefined) delete elementData.select2;
    
        // console.log(elementData)
    
        Loader.show();
        // $('html').css('overflow', 'hidden');
    
        if(elementData.field !== undefined){
            elementData[elementData.field] = element.val();
        }
    
        var sendData = {
            'value': element.val(),
            'data': elementData,
            'value_field': $('#searchField').val()
        }

        $('#searchField').attr('data-responsible', element.val());
        $('#allChats').attr('data-responsible', element.val());
        $('#unreadChats').attr('data-responsible', element.val());
    
        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: element.data('urlajax'), 
            data: sendData,
            dataType: "json",
            success: function (data) {
    
                // $('html').css('overflow', 'auto');
                Loader.hide();
    
                if (!data.error) {
                    const classUtilitites = new UtilitiesUP;
                    classUtilitites.switchReturns(data, element);
                }
    
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // $('html').css('overflow', 'auto');
                Loader.hide();
                const classUtilitites = new UtilitiesUP;
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });
    }

    const filterForNameChat = function () {

        const utilitiesClass = new UtilitiesUP;
        let timer;
        
        $('.filter-for-name-chat-keyup').each(function(){
            
            const element = $(this);

            element.on('keyup', function() {
                
                clearTimeout(timer);
                
                timer = setTimeout(function () {
                    
                    const url_ajax = element.attr("data-ajax");   
                    const searchSesponsible =  element.attr("data-responsible");
   
                    Loader.show();    
                    element.attr('disabled', 'disabled');
                    
                    let sendData = {
                        value_field : element.val(),
                        responsible : searchSesponsible
                    };
            
                    $.ajax({
                        type: "POST",
                        headers: {
                            'X-CSRF-TOKEN': CSRF_TOKEN
                        },
                        url: url_ajax,
                        data: sendData,
                        dataType: "json",
                        success: function (data) {
                            // $('html').css('overflow', 'auto');
                            console.log(data);
                            Loader.hide();
                            element.removeAttr('disabled');

                            utilitiesClass.switchReturns(data, element);
                            utilitiesClass.formSelects();
            
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            // $('html').css('overflow', 'auto');
                            Loader.hide();
                            element.removeAttr('disabled');
            
                            console.log("Erro de comunicação, por favor, recarregue a página", "Ok");
            
                        }
                    });
        
                }, 1500);            

            })


        })
        

        
        
        
    }

    const limiteCharText = function(elm)
    {
        var _this = elm;
        var limitChar = parseInt(_this.attr('maxlength'));

        if(_this.val().length > limitChar ) return;
        _this.parent().find('.limite-textarea').text("Restam: " + (limitChar - _this.val().length) + " de " +limitChar+" caractéres");
    }

    const autoHeightTextarea = (element) => {
        if($(window).width() <= 768) return;
        
        // const scrollingElement = (document.scrollingElement || document.body);
        element.style.height = "5px";
        element.style.height = (element.scrollHeight) + "px";
        // scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }

    const toggleSends = (el) => {
        if(el.val().length > 0) {
            $("#whatsapi-send-button").show();
            $("#recordButton").hide();
        } else {
            $("#whatsapi-send-button").hide();
            $("#recordButton").show();
        }
    }

    return {
        init: function () {
            
            if($(document).find('.act-open-chat').length > 0){
                chatList();
                updateHeightList();
                if($(window).width() > 992) {
                    $(window).on('resize', function () {
                        updateHeightList();
                    });
                }
            }

            if( $(document).find('.filter-for-name-chat-keyup').length > 0) {
                filterForNameChat();
            }
    
                $(document).on('click', '.act-open-chat', open);
                $(document).on('submit', "form#send-message", sendMessage);
    
                $(document).on('click', '#recordButton', startRecording);
                $(document).on('click', '#stopButton', stopRecording);
                
                $(document).on('change', '#uploadFileChat', sendFile);
                $(document).on('change', '#flow_id', selectFlow)

                $(document).on("change", "#responsibleFilter", responsibleFilter);
    
                $(document).on('keydown', '#content', function (e) {
                    if (e.which === 13 && !e.shiftKey) {
                        e.preventDefault();
                        if($('.chat-send[disabled=disabled]').length == 0) $("form#send-message").trigger('submit');
                        return false;
                    }
                });
                $(document).on('keyup', '#content', function (e) {
                    if($(document).find('#content').val() != '') $(document).find('button.chat-send').removeAttr('disabled');
                    if($(document).find('#content').val() == '') $(document).find('button.chat-send').attr('disabled','disabled');
                });
                
                $(document).on('click', '#backToContacts', toggleChatMobile);
                
                $(document).on('keyup', '.count-caracteres', function () {
                    limiteCharText($(this));
                })
                $(document).on('keyup', '.textarea-autoHeight', function () {
                    autoHeightTextarea(this);
                })

                $(document).on('keyup', '.textarea-toggle-sends', function(){
                    toggleSends($(this));
                });
            
        }
    }
}();

// export default Chats
module.exports = Chats